export default __webpack_public_path__ + "static/media/item2.af1569ce.png";